export default "__VITE_ASSET__3c17f485__"